import styled from "styled-components";

export const Dock = styled.div<{ $panelOpen?: boolean }>`
  position: fixed;
  right: 16px;
  bottom: 0;
  z-index: 9990;
  max-width: calc(100vw - 32px);
  pointer-events: none;

  > * {
    pointer-events: auto;
  }

  .sc-dock__label {
    background: ${({ $panelOpen }) => ($panelOpen ? "#005cac" : "#f8fafc")};
    color: ${({ $panelOpen }) => ($panelOpen ? "#fff" : "#1f2937")};
  }

  .sc-dock__chevron {
    transform: ${({ $panelOpen }) => ($panelOpen ? "rotate(180deg)" : "none")};
    color: ${({ $panelOpen }) =>
      $panelOpen ? "rgba(255,255,255,0.85)" : "#64748b"};
  }
`;

export const DockBottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  max-width: 100%;
`;

export const DockWindows = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 1;
  min-width: 0;
`;

export const DockWindow = styled.div<{ $minimized?: boolean }>`
  width: 300px;
  max-width: calc(100vw - 32px);
  height: 420px;
  max-height: min(420px, calc(100vh - 64px));
  background: #fff;
  border: 1px solid #d1d7db;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.12);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  ${({ $minimized }) =>
    $minimized &&
    `
    height: auto;
    .sc-dock__window-body { display: none; }
  `}
`;

export const WindowHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 10px 12px;
  background: #005cac;
  color: #fff;
  cursor: pointer;
`;

export const WindowTitle = styled.div`
  min-width: 0;

  strong {
    display: block;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    display: block;
    font-size: 11px;
    opacity: 0.85;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const WindowActions = styled.div`
  display: flex;
  gap: 4px;
  flex-shrink: 0;
`;

export const WindowBtn = styled.button<{ $danger?: boolean; $active?: boolean }>`
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 4px;
  background: ${({ $danger, $active }) =>
    $danger || $active
      ? "rgba(239, 68, 68, 0.85)"
      : "rgba(255, 255, 255, 0.15)"};
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  opacity: ${({ $active }) => ($active ? 1 : 1)};

  &:hover {
    background: ${({ $danger, $active }) =>
      $danger || $active
        ? "rgba(220, 38, 38, 0.95)"
        : "rgba(255, 255, 255, 0.25)"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const WindowBody = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background: #e5ddd5;
`;

export const DockPanel = styled.div`
  width: 320px;
  max-width: calc(100vw - 32px);
  height: 420px;
  max-height: min(420px, calc(100vh - 64px));
  background: #fff;
  border: 1px solid #d1d7db;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -4px 20px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
`;

export const PanelHead = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 10px;
  background: #005cac;
`;

export const PanelTitleWrap = styled.div`
  min-width: 0;

  h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
  }

  span {
    display: block;
    margin-top: 2px;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.8);
  }
`;

export const PanelClose = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255, 255, 255, 0.25);
  }
`;

export const PanelSearch = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 10px 10px 6px;
  padding: 0 12px;
  height: 36px;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #94a3b8;

  input {
    flex: 1;
    border: none;
    background: transparent;
    outline: none;
    font-size: 13px;
    color: #0f172a;
  }
`;

export const PanelList = styled.div`
  overflow: auto;
  flex: 1;
`;

export const ContactButton = styled.button<{ $active?: boolean; $unread?: boolean }>`
  width: 100%;
  border: none;
  border-bottom: 1px solid #f1f5f9;
  background: ${({ $active }) => ($active ? "#eef4fb" : "#fff")};
  text-align: left;
  padding: 10px 12px;
  cursor: pointer;
  display: grid;
  grid-template-columns: 40px 1fr auto;
  gap: 10px;
  align-items: center;

  &:hover {
    background: #f8fafc;
  }
`;

export const ContactAvatar = styled.span<{ $photo?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: ${({ $photo }) =>
    $photo ? "transparent" : "#005cac"};
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const ContactAvatarWrap = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
`;

export const OnlineDot = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.08);
`;

export const PanelTabs = styled.div`
  display: flex;
  gap: 4px;
  padding: 0 12px 10px;
  border-bottom: 1px solid #e2e8f0;
`;

export const PanelTab = styled.button<{ $active?: boolean }>`
  flex: 1;
  border: none;
  border-radius: 999px;
  padding: 8px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "#005cac" : "#f1f5f9")};
  color: ${({ $active }) => ($active ? "#fff" : "#475569")};
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: ${({ $active }) => ($active ? "#004a8a" : "#e2e8f0")};
  }
`;

export const ContactBadge = styled.span`
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  border-radius: 999px;
  background: #25d366;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const PanelEmpty = styled.div`
  padding: 32px 20px;
  text-align: center;
  color: #64748b;

  p {
    margin: 0 0 6px;
    font-weight: 600;
    color: #334155;
  }

  span {
    font-size: 12px;
  }
`;

export const DockBar = styled.div`
  display: flex;
  align-items: stretch;
  background: #fff;
  border: 1px solid #d1d7db;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-height: 44px;
  flex-shrink: 0;
`;

export const DockLabel = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 16px;
  border: none;
  border-right: 1px solid #e5e7eb;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  min-width: 132px;
  justify-content: center;
  transition: background 0.15s, color 0.15s;
`;

export const TotalBadge = styled.span`
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: #25d366;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Chevron = styled.span`
  margin-left: 4px;
  display: inline-flex;
  transition: transform 0.2s ease;
`;

export const Messages = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
`;

export const Bubble = styled.div<{ $mine?: boolean }>`
  max-width: 75%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 1.45;
  word-break: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08);
  align-self: ${({ $mine }) => ($mine ? "flex-end" : "flex-start")};
  background: ${({ $mine }) => ($mine ? "#dcf8c6" : "#fff")};
  border-bottom-${({ $mine }) => ($mine ? "right" : "left")}-radius: 2px;
`;

export const BubbleText = styled.span`
  display: block;
  white-space: pre-wrap;
`;

export const BubbleTime = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 10px;
  color: #94a3b8;
  text-align: right;
`;

export const VoiceCallEvent = styled.div<{
  $answered?: boolean;
  $outgoing?: boolean;
}>`
  align-self: center;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 92%;
  margin: 4px auto;
  padding: 7px 12px;
  border-radius: 999px;
  background: ${({ $answered }) => ($answered ? "#ecfdf5" : "#fff7ed")};
  border: 1px solid
    ${({ $answered }) => ($answered ? "#bbf7d0" : "#fed7aa")};
  color: ${({ $answered }) => ($answered ? "#047857" : "#c2410c")};
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;

  svg {
    flex-shrink: 0;
  }
`;

export const VoiceCallTime = styled.span`
  font-size: 10px;
  font-weight: 500;
  opacity: 0.75;
  margin-left: 4px;
`;

export const AttachmentFile = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 6px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 92, 172, 0.18);
  border-radius: 10px;
  cursor: pointer;
  text-align: left;
  color: inherit;

  &:hover {
    border-color: #005cac;
  }
`;

export const Composer = styled.form`
  display: flex;
  align-items: flex-end;
  gap: 6px;
  padding: 8px 10px;
  background: #f0f2f5;
  border-top: 1px solid #d1d7db;
`;

export const ComposerMain = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ComposerInput = styled.textarea`
  width: 100%;
  resize: none;
  border: none;
  border-radius: 20px;
  padding: 10px 14px;
  font-size: 14px;
  font-family: inherit;
  max-height: 120px;
  outline: none;
  background: #fff;
`;

export const AttachBtn = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: transparent;
  color: #64748b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
    color: #005cac;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const SendBtn = styled.button`
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: #005cac;
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FilePreview = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FilePreviewItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 6px 10px;
  background: #fff;
  border: 1px solid #dbeafe;
  border-radius: 8px;
  font-size: 12px;
`;

export const DropOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 92, 172, 0.12);
  border: 2px dashed #005cac;
  pointer-events: none;
`;

export const DropOverlayInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  color: #005cac;
  text-align: center;

  strong {
    font-size: 14px;
    color: #0f172a;
  }

  span {
    font-size: 12px;
    color: #64748b;
  }
`;

export const LoadingText = styled.div`
  text-align: center;
  color: #64748b;
  font-size: 13px;
  padding: 24px;
`;

export const IncomingBanner = styled.div`
  position: fixed;
  right: 16px;
  bottom: 88px;
  z-index: 9991;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: #111827;
  color: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
  min-width: 280px;
`;

export const IncomingBannerAvatar = styled.div<{ $photo?: boolean }>`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $photo }) => ($photo ? "transparent" : "#005cac")};
  color: #fff;
  font-size: 14px;
  font-weight: 700;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const IncomingBannerMeta = styled.div`
  flex: 1;
  min-width: 0;

  strong {
    display: block;
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  span {
    display: block;
    font-size: 12px;
    color: rgba(255, 255, 255, 0.72);
    margin-top: 2px;
  }
`;

export const IncomingBannerActions = styled.div`
  display: flex;
  gap: 8px;
  flex-shrink: 0;

  button {
    border: none;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 12px;
    cursor: pointer;
  }

  button:first-of-type {
    background: #16a34a;
    color: #fff;
  }

  button:last-of-type {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
  }
`;
